<script lang="ts">
    import cn from 'classnames';
    import type { Props } from './types';
    import s from './spinner-circle.module.css';

    import { type Action, setActionFunc } from '@uikit/actions';

    export let color: Props['color'] = null;
    export let size: Props['size'] = 20;
    export let borderWidth: Props['borderWidth'] = 2;
    export let classes: Props['classes'] = null;
    export let action: Action | undefined = undefined;

    $: style = [
        { key: 'border-bottom-color', value: 'transparent' },
        { key: 'width', value: `${size}px` },
        { key: 'height', value: `${size}px` },
        { key: 'border-width', value: `${borderWidth}px` },
    ].reduce((acc, item) => (item.value ? `${acc}${item.key}: ${item.value};` : acc), '');

    $: ({ actionFunc, actionParams } = setActionFunc(action));
</script>

<div class={cn(s.spinnerCircle, color && s[color], classes)} {style} use:actionFunc={actionParams}></div>
